import map from './parser-map';

const teamMap = map.match.team;

class Team {
  constructor(rawObj) {
    this.id = rawObj[teamMap.id];
    this.type = parseInt(rawObj[teamMap.type], 10);
    this.name = rawObj[teamMap.name];
    this.shortName = rawObj[teamMap.shortName] || this.name;
    this.provider = rawObj[teamMap.provider];
    this.active = true;
  }
}

export default Team;
